import { INgayNghiLeActionTypes } from "../../action-types/category/INgayNghiLeActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { INgayNghiLeReducer } from "../../reducer-model/category/INgayNghiLeReducer";

const initState: INgayNghiLeReducer = {
  status: eReducerStatusBase.is_not_initialization,
  ngayNghiLes: [],
};
export const ngayNghiLeReducer = (
  state: INgayNghiLeReducer = initState,
  action: INgayNghiLeActionTypes
): INgayNghiLeReducer => {
  switch (action.type) {
    case "NGAY_NGHI_LE_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "NGAY_NGHI_LE_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        ngayNghiLes: action.payload,
      };
    case "NGAY_NGHI_LE_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGAY_NGHI_LE_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        ngayNghiLeEditing: action.payload,
      };
    case "NGAY_NGHI_LE_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "NGAY_NGHI_LE_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "NGAY_NGHI_LE_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false,
      };
    case "NGAY_NGHI_LE_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "NGAY_NGHI_LE_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "NGAY_NGHI_LE_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "NGAY_NGHI_LE_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
